module.exports = __webpack_public_path__ + "static/media/house4.ab4bffe5.png";